import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "../../utils/StaticFunctions";
import MachineStates from "../../utils/MachineStates";
import Tacho from "./Tacho";
import ProgressBar from "./ProgressBar";
import './machines.css';

class MachineSmall extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    static getProgress(status, stitches, patternStitches) {

        let progressValue = Math.floor((100 / patternStitches) * stitches);

        switch (status) {
            case 1001:
                progressValue = 0;
                break;

            case 1012:
                progressValue = 100;
                break;
        }

        if (progressValue < 0) progressValue = 0;
        if (progressValue > 100) progressValue = 100;

        return progressValue;

    }

    constructor(props) {

        super(props);

        this.machineClicked = this.machineClicked.bind(this);

    }

    machineClicked() {

        if (this.props.onClick) this.props.onClick(this.props.machine);

    }

    getRemainingTime() {

        const machine = this.props.machine;

        const patternStitches = machine.pattern_stitchcounter;
        const stitches = (machine.status === 1012) ? machine.pattern_stitchcounter : machine.pattern_stitchnumber;

        const rpm = this.props.baseData.companies.currentCompany.machine_rpm / 60;
        const remainingStitches = patternStitches - stitches;

        return (remainingStitches > 0) ? Math.round(remainingStitches / rpm) : 0;    //  Time in seconds.

    }

    render() {

        const machine = this.props.machine;
        const statusClass = MachineStates.getStatusType(machine.status);

        const patternStitches = machine.pattern_stitchcounter;
        const stitches = (machine.status === 1012) ? machine.pattern_stitchcounter : machine.pattern_stitchnumber;
        const progress = MachineSmall.getProgress(machine.status, stitches, patternStitches);

        const classes = ["col-xs-12", "col-sm-6", "col-md-3", "col-lg-2", "machine", statusClass].join(' ');
        const statusColorCodes = MachineStates.getColorSetByStatus(statusClass);

        const remainingTime = (machine.status !== 1001) ? this.getRemainingTime() : null;
        const tacho = <Tacho rotationSpeed={machine.rotation_speed}/>;
        const progressBar = <ProgressBar percentage={progress} status={statusClass}/>;

        return (
            <div className={classes}>
                <div onClick={this.machineClicked} style={{cursor: 'pointer'}}>
                    <div className="header" style={{backgroundColor: statusColorCodes.color2}}>
                        <h2>{machine.alias}</h2>

                        <i style={{backgroundColor: statusColorCodes.color1}}>ok</i>
                    </div>

                    <div className="content" style={{backgroundColor: statusColorCodes.color3}}>
                        <div className="machineBlock" style={{width: '100%'}}>
                            <div className="designRemainingTime" style={{margin: '10px 0'}}>
                                {StaticFunctions.convertSecondsToFormatedString(remainingTime, true)}
                            </div>
                        </div>

                        {progressBar}
                    </div>
                </div>
            </div>
        );

    }

}

export default MachineSmall;